import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClubTableComponent from '../explorePageComponents/finance/clubTableComponent';
import Typography from '@mui/material/Typography';
import './explorePage.css';
import { useTranslation } from 'react-i18next';
import Divider from '../../../components/Divider';

const ExplorePage = React.memo(() => {
  const [t] = useTranslation();
  const [clubtableRowCount, setClubTableRowCount] = useState();
  const setRowCount = count => {
    setClubTableRowCount(count);
  };
  return (
    <div style={{ height: '100%' }}>
      <Typography sx={{ width: '33%', flexShrink: 0, fontWeight: 'bold', fontFamily: 'Montserrat', padding: '6px !important' }}>
        {t('ACCOUNTING_ITEMS')} ({clubtableRowCount} {t('ROWS')})
      </Typography>
      <Divider />
      <ClubTableComponent setRowCount={setRowCount} />
    </div>
  );
});

ExplorePage.propTypes = {
  mode: PropTypes.string,
};

export default ExplorePage;
